class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    const facetForm = this.querySelector("form");
    facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));
    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }
  static renderProductGridContainer(html) {
    const productGridContainer = document.getElementById("ProductGridContainer");
    
    if (productGridContainer) {
      if (window.Alpine) {
        window.Alpine.destroyTree(productGridContainer);
      }

      productGridContainer.innerHTML = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("ProductGridContainer").innerHTML;

      if (window.Alpine) {
        window.Alpine.initTree(productGridContainer);
      }

      // Re-initialize lazy videos that were injected into the new DOM
      FacetFiltersForm.initLazyVideos(productGridContainer);
    }

    //Dispatch event to re-initialize wishlist buttons
    document.dispatchEvent(new CustomEvent("shopify-wishlist:init"));
  }
  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElements = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter
        ? element.dataset.index === jsFilter.dataset.index
        : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter(
      (element) => !matchesIndex(element)
    );
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);
    facetsToRender.forEach((element) => {
      const targetElement = document.querySelector(
        `.js-filter[data-index="${element.dataset.index}"]`
      );
      if (targetElement) {
        targetElement.innerHTML = element.innerHTML;
      }
    });
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
    
    // Reattach event listeners after DOM update
    FacetFiltersForm.reattachEventListeners();
    
    // Always update all desktop action buttons when filters change
    const desktopActionButtons = parsedHTML.querySelectorAll(".desktop-action-buttons");
    const currentDesktopActionButtons = document.querySelectorAll(".desktop-action-buttons");
    if (desktopActionButtons.length > 0 && currentDesktopActionButtons.length > 0) {
      // Update all desktop action buttons with the same content
      const newContent = desktopActionButtons[0].innerHTML;
      currentDesktopActionButtons.forEach(button => {
        button.innerHTML = newContent;
      });
    }
    
    if (countsToRender) {
      FacetFiltersForm.renderOuterElement(
        countsToRender.closest(".mobile-filter"),
        event.target.closest(".mobile-filter"),
        ".facets__selected"
      );
    } else {
      facetsToRender.forEach((element) => {
        const source = element.closest(".mobile-filter");
        const target = source
          ? document.querySelector(
              `.mobile-filter[data-index="${source.dataset.index}"]`
            )
          : false;
        if (source && target) {
          FacetFiltersForm.renderOuterElement(
            source,
            target,
            ".facets__selected"
          );
        }
      });
    }
  }
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-drawer",
      ".active-facets-desktop",
      ".active-sort-desktop",
    ];
    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });
  }
  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".facet-actions-mobile",
      ".facet-actions-desktop",
    ];
    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });
  }
  static renderOuterElement(source, target, selector) {
    if (!source || !target || !selector) return;
    const targetElement = target.querySelector(selector);
    const sourceElement = source.querySelector(selector);
    if (sourceElement && targetElement) {
      target.querySelector(selector).outerHTML =
        source.querySelector(selector).outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  static reattachEventListeners() {
    // Find all facet-filters-form elements and reattach their event listeners
    const facetForms = document.querySelectorAll("facet-filters-form");
    facetForms.forEach((facetForm) => {
      const form = facetForm.querySelector("form");
      if (form) {
        // Remove existing listeners to avoid duplicates
        form.removeEventListener("input", facetForm.debouncedOnSubmit);
        // Reattach the input event listener
        form.addEventListener("input", facetForm.debouncedOnSubmit.bind(facetForm));
      }
    });
  }
  static initLazyVideos(container) {
    container.querySelectorAll("video.lazy").forEach(function (video) {
      for (const child of video.children) {
        if (child.tagName === "SOURCE" && child.dataset.src) {
          child.src = child.dataset.src;
        }
      }
      video.load();
      video.classList.remove("lazy");
    });
  }
  
  static getSections() {
    const productGrid = document.getElementById("product-grid");
    const productGridContainer = document.getElementById("ProductGridContainer");
    
    if (productGrid && productGrid.dataset.id) {
      return [
        {
          section: productGrid.dataset.id,
        },
      ];
    }
    
    if (productGridContainer && productGridContainer.dataset.id) {
      return [
        {
          section: productGridContainer.dataset.id,
        },
      ];
    }
    
    return [];
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const searchParams = this.createSearchParams(event.target.closest("form"));
    this.onSubmitForm(searchParams, event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    const url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1
          );
    FacetFiltersForm.renderPage(url);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}
customElements.define("facet-remove", FacetRemove);